import { apiConstants } from "@data/constants/apiConstants"
import { authConstants } from "@data/constants/authConstants"
import { cancelFlowConstants } from "@data/constants/cancelFlowConstants"
import { authService } from "@data/services/authService"

// Local cancel-flow slice. Temporary client-side state while the
// ChurnIntent backend is not yet wired. Once the back exposes
// ChurnIntent.outcome on the user/subscription resource, replace reads of
// `state.data.cancelFlow.appointment` by the resource field and treat
// this slice as a write-through cache only.
const initialState = {
    appointment: null, // { bookedAt, slot, motif, calendlyEventUri } | null
}

export function cancelFlow(state = initialState, action) {
    switch (action.type) {
        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authService.logout.name + apiConstants._SUCCESS:
            return initialState

        case cancelFlowConstants.SET_APPOINTMENT_BOOKED:
            return { ...state, appointment: action.appointment }

        case cancelFlowConstants.CLEAR_APPOINTMENT_BOOKED:
            return { ...state, appointment: null }

        case cancelFlowConstants.RESET_CANCEL_FLOW:
            return initialState

        default:
            return state
    }
}
